import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../../environments/environment';
import { QuickContactFormComponent } from '../quick-contact-form/quick-contact-form.component';

@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterLink,
    LucideAngularModule,
    QuickContactFormComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly email = environment.company.email;
  readonly phone = environment.company.phone;
  readonly phoneFormatted = environment.company.phoneFormatted;
  readonly cnpj = environment.company.cnpj;
  readonly instagramUrl = environment.company.instagramUrl;
  readonly whatsappUrl = environment.company.whatsappUrl;
  readonly copyrightYears = new Date().getFullYear() > 2025
    ? `2025 - ${new Date().getFullYear()}`
    : '2025';
}
